
import axios from 'axios';
import React from 'react'
import { API } from '../constant';
import { handleFormatResponse, handleFormatResponseForError } from '../utility';

export function useDirectusApi() {

    const fetchDirectData = async (endpoint: string) => {
        try {

            let response = await axios.get(`${API}${endpoint}`)
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    /**
     * Fetches a binary file from a Directus endpoint and triggers a browser download.
     * Automatically reads the Bearer token from localStorage.
     * @param endpoint  - The path after the base API URL (e.g. "custom/center-reports/excel")
     * @param filename  - The name to give the downloaded file (e.g. "center-reports.xlsx")
     * @param mimeType  - Optional MIME type override (defaults to the response content-type)
     */
    const fetchDirectDataBlob = async (
        endpoint: string,
        filename: string,
        mimeType?: string
    ): Promise<{ isSuccess: boolean; message: string }> => {
        try {
            const token = localStorage.getItem("token");

            const response = await axios.get(`${API}${endpoint}`, {
                responseType: 'blob',
                headers: token
                    ? { Authorization: `Bearer ${token}` }
                    : undefined,
            });

            const blob = new Blob([response.data], {
                type: mimeType || response.headers['content-type'] || 'application/octet-stream',
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return { isSuccess: true, message: 'Download started' };
        } catch (error: any) {
            return {
                isSuccess: false,
                message: error?.response?.data?.message || error?.message || 'Download failed',
            };
        }
    };

    const postDirectData = async (endpoint: string, payload: any) => {
        try {

            let response = await axios.post(`${API}${endpoint}`, payload)
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };
    const patchDirectData = async (endpoint: string, payload: any) => {
        try {

            let response = await axios.patch(`${API}${endpoint}`, payload)
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;

        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    return {
        fetchDirectData,
        fetchDirectDataBlob,
        postDirectData,
        patchDirectData
    }
}

